export default __webpack_public_path__ + "static/media/WalletConnect.6d6413a7.svg";